module.exports = __webpack_public_path__ + "static/media/carrots-instructions.52c99f84.png";